import { useTranslation } from '@mc/i18n'
import { useStaticData } from '@mc/static-data-react'

import Link from 'components/Link'
import { articlePath } from 'libs/paths'

const RelatedArticles = () => {
  const { t } = useTranslation('@mc/next')
  const { relatedArticles } = useStaticData()

  if (!relatedArticles?.length) return <></>

  return (
    <section
      className='container mc-py-10'
      data-testid='related-articles-section'
    >
      <div className='row no-gutters-vertical justify-content-center'>
        <div className='col-12 col-sm-8'>
          <h2 className='mc-text-h2 mc-text--center mc-mb-9'>
            {t('common.recommendedArticles.title.string')}
          </h2>
          <ul className='row justify-content-center no-gutters-vertical'>
            {relatedArticles.map(({ slug, title }) => (
              <li className='col-12 col-sm-6 mc-mb-6' key={slug}>
                <Link
                  className='mc-text--bare-link'
                  href={articlePath(slug)}
                  passHref
                >
                  {title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  )
}

export default RelatedArticles
